import {Button, EMPHASIS, FlexColumn, Text} from '@forecast-it/design-system';
import React from 'react';
import Styled from 'styled-components/macro';
import {EntityType} from '../Constants';

type CustomFieldsEmptyStateProps = {
	entityType: EntityType;
	onCreateCustomField: () => void;
};

const Content = Styled(FlexColumn)`
	padding: 64px 0px;
	border: 1px solid #D3D3DF;
	border-radius: 8px;
`;

const getEntityText = (entityType: string) => {
	switch (entityType) {
		case 'PROJECT':
			return 'No custom fields associated with projects.';
		case 'PHASE':
			return 'No custom fields associated with phases.';
		case 'TASK':
			return 'No custom fields associated with tasks.';
		case 'TIME_REG':
			return 'No custom fields associated with time entries.';
		default:
			return 'No custom fields associated with this entity type.';
	}
};

const CustomFieldsEmptyState = ({entityType, onCreateCustomField}: CustomFieldsEmptyStateProps): JSX.Element => {
	return (
		<Content gap="xl" alignItems="center" justifyContent="center">
			<Text>{getEntityText(entityType)}</Text>
			<Button emphasis={EMPHASIS.LOW} onPress={onCreateCustomField}>
				Create Custom Field
			</Button>
		</Content>
	);
};

export default CustomFieldsEmptyState;
